import { ITransitionParams } from "./ITransitionFactory";
import { VideoSpriteTransition } from "./VideoSpriteTransition";

export class VideoSpriteTransitionClassicMix extends VideoSpriteTransition {
    public constructor( params: ITransitionParams) {
        super(params)
    }
}